import { Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ChangeLanguageService } from './shared/language/change-language.service';
import { KeycloakAuthService } from './shared/auth/keycloak-auth.service';
import { UnloadService } from './unload.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title = 'venta-chat-portal-front';

  constructor(
    private translate: TranslateService,
    private keycloakToken: KeycloakAuthService,
    private unloadService: UnloadService,
    private languageService: ChangeLanguageService,
    ) {
    // this.translate.use('es').subscribe(() => {

    // });
    this.unloadService.ngOnInit();
  }

  ngOnInit() {
    //this.translate.use('es');
    this.keycloakToken.getToken();
    this.languageService.currentLanguage$.subscribe((language) => {
      this.translate.use(language);
    });
  }


}
